module.exports = __webpack_public_path__ + "media/ecu/bghead-63d6b79d.png";